export const enum DeviceManagementActions {
  CreatePackage = 'Create New Package',
  AddDevices = 'Add Devices',
  RemoveDevices = 'Remove Devices',
  ReplaceDevices = 'Replace Devices',
  RebootGateWay = 'Reboot Gateway',
  SetupWifi = 'Setup WIFI',
}

export const enum DeviceManagementDeviceNames {
  Tracker = 'Tracker',
  Scale = 'Scale',
  PulseOximeter = 'Pulse Oximeter',
  Thermometer = 'Thermometer',
  BloodPressureMonitor = 'Blood Pressure Monitor',
  Inhaler = 'Inhaler',
}

export const enum DeviceManagementWizardNextButtonActionNames {
  NextWizardStage = 'goToNextWizardStage',
  NextSelectedDevice = 'goToNextSelectedDevice',
}

export const enum DeviceManagementWizardBackButtonActionNames {
  PreviousWizardStage = 'goToPreviousWizardStage',
  PreviousSelectedDevice = 'goToPreviousSelectedDevice',
}

export type DeviceManagementAvailableDevice = {
  name: string | null
  deviceId: string | null
  isSelected: boolean
  hasSkippedGatewayConnection: boolean
  hasAttemptedGatewayConnection: boolean
  hasSuccessfulGatewayConnection: boolean
  hasSuccessfulRemovalFromGateway: boolean
  hasSkippedDataConnection: boolean
  hasAttemptedDataConnection: boolean
  hasSuccessfulDataConnection: boolean
  deviceIndex: number | null
}

export const DeviceManagementDefaultAvailableDevice = {
  name: null,
  deviceId: null,
  isSelected: false,
  hasSkippedGatewayConnection: false,
  hasAttemptedGatewayConnection: false,
  hasSuccessfulGatewayConnection: false,
  hasSuccessfulRemovalFromGateway: false,
  hasSkippedDataConnection: false,
  hasAttemptedDataConnection: false,
  hasSuccessfulDataConnection: false,
  deviceIndex: null,
}

export const enum DeviceManagementComponents {
  ConnectGateway = 'DeviceManagementConnectGateway',
  SelectDevices = 'DeviceManagementSelectDevices',
  ConnectDevices = 'DeviceManagementConnectDevices',
  CheckConnectivity = 'DeviceManagementCheckConnectivity',
  RebootGateWay = 'DeviceManagementRebootGateway',
  SetupWifi = 'DeviceManagementSetupWifi',
}

export const MacAddressRegex = /^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/

export const DeviceManagementWizardStages = {
  [DeviceManagementActions.CreatePackage]: [
    {
      title: 'Setup Gateway',
      component: DeviceManagementComponents.ConnectGateway,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextWizardStage,
    },
    {
      title: 'Add Devices',
      component: DeviceManagementComponents.SelectDevices,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextWizardStage,
      backButtonAction: DeviceManagementWizardBackButtonActionNames.PreviousWizardStage,
    },
    {
      title: 'Connect Each Device',
      component: DeviceManagementComponents.ConnectDevices,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextSelectedDevice,
      backButtonAction: DeviceManagementWizardBackButtonActionNames.PreviousSelectedDevice,
    },
    {
      title: 'Check Connectivity',
      component: DeviceManagementComponents.CheckConnectivity,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextWizardStage,
      backButtonAction: DeviceManagementWizardBackButtonActionNames.PreviousWizardStage,
    },
  ],
  [DeviceManagementActions.AddDevices]: [
    {
      title: 'Connect To Gateway',
      component: DeviceManagementComponents.ConnectGateway,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextWizardStage,
    },
    {
      title: 'Add Devices',
      component: DeviceManagementComponents.SelectDevices,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextWizardStage,
      backButtonAction: DeviceManagementWizardBackButtonActionNames.PreviousWizardStage,
    },
    {
      title: 'Connect Each Device',
      component: DeviceManagementComponents.ConnectDevices,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextSelectedDevice,
      backButtonAction: DeviceManagementWizardBackButtonActionNames.PreviousSelectedDevice,
    },
    {
      title: 'Check Connectivity',
      component: DeviceManagementComponents.CheckConnectivity,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextWizardStage,
      backButtonAction: DeviceManagementWizardBackButtonActionNames.PreviousWizardStage,
    },
  ],
  [DeviceManagementActions.RemoveDevices]: [
    {
      title: 'Connect To Gateway',
      component: DeviceManagementComponents.ConnectGateway,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextWizardStage,
    },
    {
      title: 'Select Devices',
      component: DeviceManagementComponents.SelectDevices,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextWizardStage,
      backButtonAction: DeviceManagementWizardBackButtonActionNames.PreviousWizardStage,
    },
  ],
  [DeviceManagementActions.ReplaceDevices]: [
    {
      title: 'Connect To Gateway',
      component: DeviceManagementComponents.ConnectGateway,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextWizardStage,
    },
    {
      title: 'Select Devices',
      component: DeviceManagementComponents.SelectDevices,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextWizardStage,
      backButtonAction: DeviceManagementWizardBackButtonActionNames.PreviousWizardStage,
    },
    {
      title: 'Connect Each Device',
      component: DeviceManagementComponents.ConnectDevices,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextSelectedDevice,
      backButtonAction: DeviceManagementWizardBackButtonActionNames.PreviousSelectedDevice,
    },
    {
      title: 'Check Connectivity',
      component: DeviceManagementComponents.CheckConnectivity,
      nextButtonAction: DeviceManagementWizardNextButtonActionNames.NextWizardStage,
      backButtonAction: DeviceManagementWizardBackButtonActionNames.PreviousWizardStage,
    },
  ],
  [DeviceManagementActions.RebootGateWay]: [
    {
      title: 'Reboot Gateway',
      component: 'DeviceManagementRebootGateway',
    },
  ],
  [DeviceManagementActions.SetupWifi]: [
    {
      title: 'Setup WIFI',
      component: 'DeviceManagementSetupWifi',
    },
  ],
}
